import React, { FC } from "react"
import { GlobalStyles } from "@mui/material"
import { SnackbarProvider } from "notistack"

import CustomErrorSnackbar from "~/components/error-snackbar/CustomErrorSnackbar"
import CustomSuccessSnackbar from "~/components/snackbar/CustomSuccessSnackbar"

interface Props {
  children: React.ReactNode
}

const CustomSnackbarProvider: FC<Props> = ({ children }) => {
  const htmlTag = document.documentElement
  const dirAttribute = htmlTag.getAttribute("dir")
  const currentDirection = dirAttribute === "rtl" ? "rtl" : "ltr"

  return (
    <>
      <GlobalStyles
        styles={{
          ".notistack-SnackbarContainer": {
            top: "72px !important",
          },
          ".notistack-Snackbar": {
            width: 420,
            maxWidth: "calc(100vw - 40px)",
          },
          ".notistack-MuiContent": {
            width: "100%",
            minHeight: 64,
            padding: "12px 20px",
            fontSize: "1rem",
          },
          ".notistack-Snackbar [role='alert']": {
            width: "100%",
            minHeight: 64,
            padding: "12px 20px",
            fontSize: "1rem",
          },
          "@media (max-width: 599.95px)": {
            ".notistack-Snackbar": {
              width: "100%",
              maxWidth: "none",
            },
          },
        }}
      />

      <SnackbarProvider
        style={{ fontFamily: "iran-sans", direction: currentDirection }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        Components={{
          error: CustomErrorSnackbar,
          success: CustomSuccessSnackbar,
        }}
      >
        {children}
      </SnackbarProvider>
    </>
  )
}

export default CustomSnackbarProvider
